export default {
  RETRIEVED_PERSONS: store => {
    return store.persons;
  }
};
